import { useTranslation } from 'react-i18next';

import { useGetIssueAssessmentHistory } from '@/hooks/queries';

import { useDashboardStore } from '../../../useDashboardStore';
import { convertDateRangeValues } from '../../filterHelpers';
import LineChartWidget from '../../line-chart-widget/LineChartWidget';
import { calculateOpenIssues } from './openIssuesOverTimeUtils';

export const OpenIssuesOverTime = () => {
  const { t } = useTranslation(['common'], {
    keyPrefix: 'dashboard.widgets.openIssuesOverTime',
  });
  const { loading, values } = useOpenIssuesOverTime();

  return (
    <LineChartWidget
      values={values?.map((v) => ({ x: new Date(v.x), y: v.y }))}
      isLoading={loading}
      xTitle={t('xTitle')}
      yTitle={t('yTitle')}
    />
  );
};

const useOpenIssuesOverTime = () => {
  const { filters } = useDashboardStore();
  const { startDate, endDate } = convertDateRangeValues(filters.dateRange);

  const { loading, data } = useGetIssueAssessmentHistory({
    queryArgs: {
      startDate: startDate ? startDate.toISOString() : null,
      endDate: endDate ? endDate.toISOString() : null,
    },
  });

  return {
    values: data?.issue_assessment_audit
      ? calculateOpenIssues(
          'day',
          data.issue_assessment_audit,
          startDate,
          endDate
        )
      : undefined,
    loading,
  };
};
